// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.prem-hero {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 8px;
  padding: 32px 20px;
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-sm);
}

.prem-hero svg {
  color: var(--brand);
}

.prem-hero-on {
  background: linear-gradient(180deg, #fffbeb 0%, var(--surface) 100%);
  border-color: #fcd34d;
}

.prem-hero-on svg {
  color: #d97706;
}

.prem-hero h2 {
  font-family: var(--font-display);
  font-size: 1.3rem;
  font-weight: 800;
}

.prem-price {
  font-family: var(--font-display);
  font-size: 2.2rem;
  font-weight: 800;
  line-height: 1;
  color: var(--text);
}

.prem-price span {
  font-size: 1.2rem;
}

.prem-price em {
  font-style: normal;
  font-size: 0.95rem;
  font-weight: 600;
  color: var(--muted);
}

.prem-badge {
  margin-top: 6px;
  padding: 4px 12px;
  border-radius: var(--radius-pill);
  background: #d1fae5;
  color: #065f46;
  font-size: 0.8rem;
  font-weight: 700;
}

.prem-list {
  list-style: none;
  display: flex;
  flex-direction: column;
  margin-top: 12px;
}

.prem-list li {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 12px 0;
  border-bottom: 1px solid var(--border);
  font-size: 0.88rem;
  line-height: 1.5;
  color: var(--text-soft);
}

.prem-list li:last-child {
  border-bottom: 0;
  padding-bottom: 0;
}

.prem-ico {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border-radius: 8px;
  background: var(--brand-50);
  color: var(--brand);
}

.prem-check {
  flex-shrink: 0;
  margin-left: auto;
  color: #16a34a;
}
`, "",{"version":3,"sources":["webpack://./src/app/account/Premium.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,QAAQ;EACR,kBAAkB;EAClB,0BAA0B;EAC1B,+BAA+B;EAC/B,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oEAAoE;EACpE,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,iCAAiC;EACjC,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,eAAe;EACf,sCAAsC;EACtC,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,cAAc;AAChB","sourcesContent":[".prem-hero {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  gap: 8px;\n  padding: 32px 20px;\n  background: var(--surface);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-lg);\n  box-shadow: var(--shadow-sm);\n}\n\n.prem-hero svg {\n  color: var(--brand);\n}\n\n.prem-hero-on {\n  background: linear-gradient(180deg, #fffbeb 0%, var(--surface) 100%);\n  border-color: #fcd34d;\n}\n\n.prem-hero-on svg {\n  color: #d97706;\n}\n\n.prem-hero h2 {\n  font-family: var(--font-display);\n  font-size: 1.3rem;\n  font-weight: 800;\n}\n\n.prem-price {\n  font-family: var(--font-display);\n  font-size: 2.2rem;\n  font-weight: 800;\n  line-height: 1;\n  color: var(--text);\n}\n\n.prem-price span {\n  font-size: 1.2rem;\n}\n\n.prem-price em {\n  font-style: normal;\n  font-size: 0.95rem;\n  font-weight: 600;\n  color: var(--muted);\n}\n\n.prem-badge {\n  margin-top: 6px;\n  padding: 4px 12px;\n  border-radius: var(--radius-pill);\n  background: #d1fae5;\n  color: #065f46;\n  font-size: 0.8rem;\n  font-weight: 700;\n}\n\n.prem-list {\n  list-style: none;\n  display: flex;\n  flex-direction: column;\n  margin-top: 12px;\n}\n\n.prem-list li {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  padding: 12px 0;\n  border-bottom: 1px solid var(--border);\n  font-size: 0.88rem;\n  line-height: 1.5;\n  color: var(--text-soft);\n}\n\n.prem-list li:last-child {\n  border-bottom: 0;\n  padding-bottom: 0;\n}\n\n.prem-ico {\n  flex-shrink: 0;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 30px;\n  height: 30px;\n  border-radius: 8px;\n  background: var(--brand-50);\n  color: var(--brand);\n}\n\n.prem-check {\n  flex-shrink: 0;\n  margin-left: auto;\n  color: #16a34a;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
